import React from 'react';
import { Spinner, Intent } from "@blueprintjs/core";


const Loader = ({ intent, ...props}) => {
    let _intent;

    switch (intent) {
        case 'none':
            _intent = Intent.NONE;
            break;
        case 'success':
            _intent = Intent.SUCCESS;
            break;
        case 'danger':
            _intent = Intent.DANGER;
            break;
        case 'warn':
            _intent = Intent.WARNING;
            break;
        default:
            _intent = Intent.PRIMARY;
            break;
    }
    return (
        <Spinner intent={_intent} {...props}/>
    );
};

export default Loader;